// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2NOoS","unreadBadge":"styles_unreadBadge__3I7t9","modalContent":"styles_modalContent__3MN9f","modal":"styles_modal__2nItX"};